import { IExtendedContext } from '../../../../types/extendedContext';

import { EPresetType } from './types';
import { ELEMENTS_VISIBILITY_PRESET } from './constants';
import { setElementsVisibilityPreset } from '../../../../../shared/ServicePickerWidget/actions/elementsVisibility';

export interface ISetElementsVisibilityPresetHandlerParams {
  source: EPresetType | undefined;
}

export const setElementsVisibilityPresetHandler =
  (context: IExtendedContext) =>
  (params: ISetElementsVisibilityPresetHandlerParams): boolean => {
    const source = params.source;

    if (source && ELEMENTS_VISIBILITY_PRESET[source]) {
      context.store.dispatch(setElementsVisibilityPreset(ELEMENTS_VISIBILITY_PRESET[source]));

      return true;
    }

    return false;
  };
